module.exports = __webpack_public_path__ + "static/media/account.d9fd34ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/account.svg
// module id = 667
// module chunks = 0